import saveAs from 'file-saver';

/**
 * @class File
 * @classdesc Represents file dto
 */
export class File {
    content;
    fileName;
    mediaType;
}

/**
 * @param {string} base64 - string encoded in base64 format that represents a file
 * @returns {Uint8Array}
 */
export function base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}

/**
 * @param data
 * @param {string} contentType
 * @returns {Blob}
 */
export function saveByteArray(data, contentType) {
    return new Blob(data, { type: contentType });
}

/**
 * @param {File} file
 */
export function downloadFile(file) {
    const sampleBytes = base64ToArrayBuffer(file.content);
    const blob = saveByteArray([sampleBytes], file.mediaType);

    const fileName = file.fileName + '.xlsx'; //TODO remove it when back end will generate files with extensions

    saveAs(blob, fileName);
}


// WEBPACK FOOTER //
// ./src/common/utils/files.js